export default __webpack_public_path__ + "i18n/tr.efe3a995da8f333ee5b2afb8720f6978.json";